import { render, staticRenderFns } from "./TiCalculos.vue?vue&type=template&id=45d16aac"
import script from "./TiCalculos.vue?vue&type=script&lang=js"
export * from "./TiCalculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports